import type {PerkUsagePreviewComponentProps} from '@cohort/merchants/apps';

export const DiscordPrivateAccessPerkIntegrationsUsagePreviewComponent: React.FC<
  PerkUsagePreviewComponentProps
> = ({perk}) => {
  return <div>DiscordPrivateAccessPerkIntegrationsUsagePreviewComponent - TODO - {perk.id}</div>;
};
